import { Card } from "@/components/ui/card";
import { Building2, Plus } from "lucide-react";

export const EmptyGymState = () => {
  return (
    <Card className="p-8 rounded-xl bg-gradient-to-br from-card/80 to-card/40 border border-border/50">
      <div className="flex flex-col items-center gap-4 text-center">
        <div className="p-4 rounded-full bg-muted/50">
          <Building2 className="h-10 w-10 text-muted-foreground/50" />
        </div>
        <div className="space-y-1">
          <p className="text-lg font-medium text-foreground">
            No tienes ningún gimnasio
          </p>
          <p className="text-sm text-muted-foreground">
            Crea tu primer gimnasio para comenzar a gestionar
          </p>
        </div>
      </div>
    </Card>
  );
};